import { BorderProps, FlexProps } from "@chakra-ui/react";

import { colors } from "src/colors";

const borderStyle: BorderProps = {
  borderWidth: 1,
  borderStyle: "solid"
};

export type BadgeVariantType = "filledBlue" | "outlinedBlue";

export const BADGE_THEME: { [key in BadgeVariantType]: FlexProps } = {
  filledBlue: {
    bg: colors.blue[500],
    color: colors.white.off
  },

  outlinedBlue: {
    bg: "transparent",
    color: colors.blue[500],

    ...borderStyle,
    borderColor: colors.blue[500]
  }
};
